import DOMPurify from 'dompurify';

export const sanitizeInfoHtml = (html) =>
    DOMPurify.sanitize(html || '').replace(/<a\b[^>]*>/gi, (anchor) => {
        const anchorWithoutTargetOrRel = anchor
            .replace(/\s+target\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, '')
            .replace(/\s+rel\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, '');

        return anchorWithoutTargetOrRel.replace(/>$/, ' target="_blank" rel="noopener noreferrer">');
    });
